import React from 'react';
import PropTypes from 'prop-types';
import InvestorReport from 'components/InvestorReport';
import './InvestorDoubleReportBlock.scss';

const InvestorDoubleReportBlock = ({ heading, reports, anchorId }) => {
    return (
        <div className="investor-double-report-block" id={anchorId}>
            <div className="investor-double-report-block__container">
                {heading && <h2 className="investor-double-report-block__heading">{heading}</h2>}
                {reports && reports.length > 0 ? (
                    <div className="investor-double-report-block__reports">
                        {reports.map((report, index) => (
                            <div className="investor-double-report-block__item" key={index}>
                                <InvestorReport {...report} />
                            </div>
                        ))}
                    </div>
                ) : null}
            </div>
        </div>
    );
};

InvestorDoubleReportBlock.propTypes = {
    heading: PropTypes.string,
    reports: PropTypes.arrayOf(PropTypes.shape(InvestorReport.propTypes)),
    anchorId: PropTypes.string
};

export default InvestorDoubleReportBlock;


// WEBPACK FOOTER //
// ./src/components/InvestorDoubleReportBlock/InvestorDoubleReportBlock.jsx